
<!--
 * @Author: redu842 2150673512@qq.com
 * @Date: 2024-11-29 16:23:52
 * @LastEditors: redu842 2150673512@qq.com
 * @LastEditTime: 2024-11-29 17:22:59
 * @FilePath: \study-our\src\views\homepage.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div class="myhomeBody">
    <div class="titleBox">
      <van-search v-model="value" placeholder="请输入搜索关键词" />
    </div>
    <div class="mainBox">
      <div class="cardBox" v-for="item in 20" @click="gotoMypage">
        <div class="cardImgBox">
          <img src="../assets/fhobnjtvfckx1hz2t8bq.jpg" alt style="width:100%;height:100%" />
        </div>
        <div class="textbox">
          <div class="textBoxTitle">故宫博物馆</div>
          <div class="textBoxTitle2">故宫博物院是我国现存规模最大、保存最完整的古代宫殿建筑群</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      value: ""
    };
  },
  methods: {
    gotoMypage() {
      this.$router.push("/introduce");
    }
  }
};
</script>

<style>
.myhomeBody {
  width: 100%;
  height: 100%;
  /* background-color: red; */
}
.titleBox {
  height: 50px;
  width: 100%;
  background-color: aqua;
  margin-top: 10px;
}
.mainBox {
  height: calc(100vh - 60px);
  /* background-color: royalblue; */
  padding: 10px 0;
  overflow: auto;
}
.cardBox {
  height: 100px;
  width: 95%;
  background-color: #fff;
  margin-left: 2.5%;
  border-radius: 5px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12), 0 0 6px rgba(0, 0, 0, 0.04);
  display: flex;
  justify-content: space-around;
  align-items: center;
  margin-bottom: 20px;
}
.cardImgBox {
  width: 90px;
  height: 90px;
  /* background-color: red; */
}
.textbox {
  width: calc(100% - 100px);
  height: 90px;
  /* background-color: aqua; */
  padding: 10px;
}
.textBoxTitle {
  height: 40px;
  width: 100%;
}
.textBoxTitle2 {
  height: 40px;
  width: 100%;
  font-size: 12px;
  color: #7c7c7c;
  overflow: hidden;
}
</style>